// extracted by mini-css-extract-plugin
export default {"container":"SongDetailsLessonNonPlayActionIos_container__w75Ud","prompt":"SongDetailsLessonNonPlayActionIos_prompt__vl+N0"};